import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonPrimary from "~/vue/atoms/buttons/ButtonPrimary.vue";

import { getGlobalTranslation } from "~/js/composables/translations";

interface Props {
	id: string;
	filename: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonDownloadTable',
  props: {
    id: {},
    filename: {}
  },
  setup(__props: any) {

const props = __props;

const downloadCSVFile = (csv_data) => {
	// Create CSV file object and feed our
	// csv_data into it
	let CSVFile = new Blob(["\ufeff" + csv_data], { type: "text/csv;encoding:utf-8,{header:true}" });

	// Create to temporary link to initiate
	// download process
	let temp_link = document.createElement("a");

	// Download csv file
	temp_link.download = `${props.filename}.csv`;
	let url = window.URL.createObjectURL(CSVFile);
	temp_link.href = url;

	// This link should not be displayed
	temp_link.style.display = "none";
	document.body.appendChild(temp_link);

	// Automatically click the link to trigger download
	temp_link.click();
	document.body.removeChild(temp_link);
};

const onDownload = () => {
	if (document.getElementById(props.id)) {
		// Variable to store the final csv data
		let csv_data = [];

		// Get each row data
		let rows = document.getElementById(props.id).getElementsByTagName("tr");
		for (let i = 0; i < rows.length; i++) {
			// Get each column data
			let cols = rows[i].querySelectorAll("td,th");

			// Stores each csv row data
			let csvrow = [];
			for (let j = 0; j < cols.length; j++) {
				// Get the text data of each cell
				// of a row and push it to csvrow
				if (cols[j].nodeName === "TH" && j > 0 && i > 0) {
					csvrow.push("");
				} else {
					csvrow.push(cols[j].querySelector(".js-table-cell")?.textContent);
				}
			}

			// Combine each column value with comma
			csv_data.push(csvrow.join(";"));
		}

		// Combine each row data with new line character
		csv_data = csv_data.join("\n");

		// Call this function to download csv file
		downloadCSVFile(csv_data);
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonPrimary, {
    size: "small",
    icon: "download",
    type: "button",
    content: _unref(getGlobalTranslation)('Download table'),
    download: "",
    "icon-position": "after",
    onClick: onDownload
  }, null, 8, ["content"]))
}
}

})